import { player_x, player_y } from "./constants";
import { trySelectUnit } from "./radio";

const flagBox = document.getElementById("flag-box") as HTMLCanvasElement

interface IObject {
    step(delta: number) : void
    draw(ctx:CanvasRenderingContext2D) : void
}


export class UnitAttack{
    range:number;
    damage:number;
    target:IUnit|null=null;
    constructor(range: number, damage: number){
        this.range = range;
        this.damage = damage;
    }

    step(delta: number, x:number, z:number, clr:string){
        let low_dist = this.range ** 2;
        //todo: checking every frame is far too much
        this.target = null;
        for(const u of units){
            const unit = u.unit;
            if(unit.colour == clr){continue;}
            const sqrd_dist = (unit.x - x) ** 2 + (unit.z - z) ** 2;
            if (sqrd_dist < low_dist){
                low_dist = sqrd_dist;
                this.target = u;
            }
        };
        if(this.target != null){
            this.target.unit.health -= this.damage * delta;
            if(this.target.unit.health < 0){
                removeUnit(this.target)
            }
        }
    }
}

export class Unit implements IObject{
    x: number;
    z: number;
    x_v: number;
    z_v: number;

    health: number;
    attack: UnitAttack;

    colour: string;

    constructor(x: number, z:number, colour:string, attack:UnitAttack){
        this.x = x;
        this.z = z;

        this.colour = colour;
        this.health = 1;
        this.attack = attack;

        this.x_v = 0;
        this.z_v = 0;
    }

    step(delta: number){
        this.x += this.x_v * delta;
        this.z += this.z_v * delta;
        this.attack.step(delta, this.x, this.z, this.colour);
    }
    
    draw(ctx:CanvasRenderingContext2D){
        ctx.fillStyle=this.colour;
        ctx.beginPath()
        ctx.arc(this.x, this.z, this.health * 5 + 5, 0, Math.PI*2);
        ctx.fill()
        ctx.fillStyle="black";
        if(this.attack.target){
            ctx.beginPath()
            ctx.arc(this.x, this.z, this.health * 5 + 5, 0, Math.PI*2);
            ctx.stroke()
        }
    }

    remove(){

    }
}

export interface IUnit extends IObject {
    unit: Unit
}

export class Enemy implements IUnit{
    unit: Unit;
    z_v: number;
    x_v: number;
    constructor(x: number, z:number){
        this.unit = new Unit(x, z, "red", new UnitAttack(100, 0.01))
        this.z_v = 1;
        this.x_v = (player_x - x) / Math.sqrt((player_x - x) ** 2 + (player_y - z) ** 2)
    }
    step(delta: number){
        //slow down if injured
        const speed = this.unit.attack.target ? 0.5 : this.unit.health + 100
        this.unit.z_v = speed * this.z_v;
        this.unit.x_v = speed * this.x_v;
        this.unit.step(delta);
    }
    draw(ctx:CanvasRenderingContext2D){
        this.unit.draw(ctx);
    }
}


export class Ally implements IObject, IUnit{
    unit: Unit;
    html: HTMLImageElement;
    radioQueue: string[] = [];
    constructor(x: number, z:number){
        this.unit = new Unit(x, z, "green", new UnitAttack(100, 0.01))
        this.html = document.createElement("img")
        this.html.className = "radio-request"
        this.html.src = "artillery/phone.png"
        flagBox.appendChild(this.html)
        this.html.onclick = () => {
            trySelectUnit(this);
        }
    }
    newRadioEvent(event:string){
        this.radioQueue.push(event);
    }
    step(delta: number){
        this.unit.step(delta);
        this.html.style.top = this.unit.z+10 + "px";
        this.html.style.left = this.unit.x + "px";
    }
    draw(ctx:CanvasRenderingContext2D){
        this.unit.draw(ctx);
        this.html.style.display = this.unit.attack.target ? "block" : "none";
    }
}

export const units: IUnit[] = [];

export function removeUnit(unit:IUnit){
    const id = units.indexOf(unit);
    units.splice(id, 1);
}